import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class AddressEntity extends Entity {
    constructor() {
        super(...arguments);
        this.address1 = '';
        this.address2 = null;
        this.address3 = null;
        this.addressId = 0;
        this.attentionTo = null;
        this.city = '';
        this.company = null;
        this.creationByUserId = '';
        this.creationDTTM = new Date(0);
        this.department = null;
        this.geoCountryId = 0;
        this.geoCountryName = '';
        this.geoTerritoryId = 0;
        this.geoTerritoryName = '';
        this.isActive = false;
        this.isBilling = false;
        this.isDefault = false;
        this.isPhysical = false;
        this.isShipping = false;
        this.postalCode = '';
        this.title = null;
        this.updatedByUserId = null;
        this.updatedDTTM = null;
    }
    pk() {
        return this.addressId.toString();
    }
}
AddressEntity.schema = { creationDTTM: ISODate, updatedDTTM: ISODate };
AddressEntity.key = 'Address';
export { AddressEntity };
